import { render, staticRenderFns } from "./index.vue?vue&type=template&id=23db84c2&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23db84c2')) {
      api.createRecord('23db84c2', component.options)
    } else {
      api.reload('23db84c2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=23db84c2&", function () {
      api.rerender('23db84c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseRequests/index.vue"
export default component.exports